<div class="infoPage-Preview-Window">
  <div
    *ngIf="isInfoPagePrintWarning"
    class="infoPagePrintWarningText {{
      isInfoPagePrintClicked ? 'hide-warningText' : 'show-warningText'
    }}">
    {{ warningMessage }}
  </div>

  <div *ngIf="infoPageData" class="print-page {{ pageSize }}">
    <div class="logo" title="PACTrak" *ngIf="!arInvoicePrints.length">
      <img src="assets/Logo.svg" alt="" />
    </div>

    <ng-container *ngFor="let sectionKey of objectKeys(infoPageData)">
   <ng-container *ngIf="skipNestedBagSections(sectionKey)"
      >
      <div class="section-header ibc-heading-h6-small-bold">
        {{ printService.getHeaderSectionKeys(sectionKey) }}
      </div>

      <table class="ibc-print-table">
        <thead>
          <tr>
            <ng-container
              *ngFor="let item of summaryCustomiseTableColumns[sectionKey]">
              <th
                *ngIf="
                  commonTableService.displaySelectedColumnsToTable(
                    item.key,
                    summaryCustomiseTableColumns[sectionKey],
                    displayedColumns[sectionKey]
                  )
                "
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <div class="ibc-body-text-large-bold table-text">{{ item.label }}</div>
              </th>
            </ng-container>
          </tr>
            <tr *ngIf="showNumberRangeSubheader(sectionKey)">
            <ng-container *ngFor="let item of summaryCustomiseTableColumns[sectionKey]">
              <th
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'"
                *ngIf="commonTableService.displaySelectedColumnsToTable(item.key, summaryCustomiseTableColumns[sectionKey], displayedColumns[sectionKey])"
               >
                <ng-container *ngIf="item.key === 'setRange'; else addDefaultCell">
                  <div class="ranges-sub-header-row">
                    <div class="ranges-sub-header">Start No.</div>
                    <div class="ranges-sub-header">End No.</div>
                    <div class="ranges-sub-header">Last Used No.</div>
                    <div class="ranges-sub-header">Priority</div>
                  </div>
                </ng-container>
                <ng-template #addDefaultCell>
                </ng-template>
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of dataSources[sectionKey]">
            <ng-container
              *ngFor="let item of summaryCustomiseTableColumns[sectionKey]">
              <td
                *ngIf="
                  commonTableService.displaySelectedColumnsToTable(
                    item.key,
                    summaryCustomiseTableColumns[sectionKey],
                    displayedColumns[sectionKey]
                  )
                "
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <ng-container *ngIf="item.key === 'setRange'; else defaultCell">
                  <div style="font-size: 11px;">
                    <div
                      *ngFor="let rangeval of element[item.key]"
                      class="range-values-row">
                      <div class="ranges-value">{{ rangeval.startNumber }}</div>
                      <div class="ranges-value">{{ rangeval.endNumber }}</div>
                      <div class="ranges-value">{{ rangeval.lastUsedNumber }}</div>
                      <div class="ranges-value">{{ rangeval.priority }}</div>
                    </div>
                  </div>
              </ng-container>

               <ng-template #defaultCell>
                <span
                  class="ibc-body-text-regular table-text {{
                    commonTableService.isHyperlink(item.label, isFrom)
                      ? 'text-hyperlink'
                      : ''
                  }}">
                  {{
                    item.key !== 'date'
                      ? element[item.key]
                      : (element.date | date: dateFormat)
                  }}
                </span>
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </ng-container>
   </ng-container>
<!-- AR invoice -->
    <div class="ar-invoice-page" *ngFor="let arInvoicePrint of arInvoicePrints">
      <div class="ar-invoice-row ar-invoice-header">
        <div>
          <img class="ar-invoice-logo" src="assets/Logo.svg" alt="" />
          <div class="ar-invoice-company">International Bonded Couriers</div>
        </div>
        <div class="ar-invoice-meta">
          <div *ngIf="isFieldSelected('arInvoiceInfo', 'invoiceDate')">
            Invoice Date: {{ arInvoicePrint.invoiceDate | date: 'MM/dd/yyyy' }}
          </div>
          <div *ngIf="isFieldSelected('arInvoiceInfo', 'dueDate')">
            Due Date: {{ arInvoicePrint.dueDate | date: 'MM/dd/yyyy' }}
          </div>
          <div *ngIf="isFieldSelected('arInvoiceInfo', 'accountNumber')">
            Account Number: {{ arInvoicePrint.accountNumber }}
          </div>
          <div *ngIf="isFieldSelected('arInvoiceInfo', 'invoiceNumber')">
            Invoice Number: {{ arInvoicePrint.invoiceNumber }}
          </div>
        </div>
      </div>

      <div class="ar-invoice-row ar-invoice-addresses">
        <div>
          <ng-container *ngIf="isFieldSelected('arInvoiceInfo', 'billTo')">
            <div class="ar-bold">Accounts Payable:</div>
            <div class="ar-bold">{{ arInvoicePrint.accountName }}</div>
            <div *ngIf="arInvoicePrint.address1">
              {{ arInvoicePrint.address1 }}
            </div>
            <div *ngIf="arInvoicePrint.address2">
              {{ arInvoicePrint.address2 }}
            </div>
            <div *ngIf="arInvoicePrint.cityStateZip">
              {{ arInvoicePrint.cityStateZip }}
            </div>
            <div *ngIf="arInvoicePrint.country">
              {{ arInvoicePrint.country }}
            </div>
          </ng-container>
        </div>
        <div class="ar-invoice-meta">
          <ng-container *ngIf="arInvoicePrint.remitTo?.length">
            <div class="ar-bold">Remit to:</div>
            <div *ngFor="let line of arInvoicePrint.remitTo">{{ line }}</div>
          </ng-container>
        </div>
      </div>

      <div class="ar-invoice-notice" *ngIf="arInvoicePrint.notice">
        {{ arInvoicePrint.notice }}
      </div>

      <table class="ar-invoice-table" *ngIf="arChargeColumns.length">
        <colgroup>
          <col
            *ngFor="let col of arChargeColumns"
            [style.width.pt]="arColumnWidthsPt[col.key]" />
        </colgroup>
        <thead>
          <tr>
            <th
              scope="col"
              *ngFor="let col of arChargeColumns"
              [class.ar-amount]="arRightAlignedKeys.has(col.key)">
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let shipment of arInvoicePrint.shipmentDetails">
            <td
              *ngFor="let col of arShipmentColumns"
              [ngSwitch]="col.key"
              [class.ar-nowrap]="arNoWrapKeys.has(col.key)"
              [class.ar-amount]="arRightAlignedKeys.has(col.key)">
              <ng-container *ngSwitchCase="'shipmentDate'">{{
                shipment.shipmentDate | date: 'MM/dd/yyyy'
              }}</ng-container>
              <ng-container *ngSwitchCase="'consignee'">
                <div *ngFor="let line of shipment.consignee?.lines">
                  {{ line }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'pieces'">{{
                shipment.pieces || 1
              }}</ng-container>
              <ng-container *ngSwitchDefault>{{
                shipment[col.key]
              }}</ng-container>
            </td>
            <td
              *ngIf="arChargeBlockColumns.length"
              class="ar-charge-block"
              [attr.colspan]="arChargeBlockColumns.length">
              <table class="ar-charge-lines" *ngIf="shipment.charges?.length">
                <colgroup>
                  <col
                    *ngFor="let col of arChargeBlockColumns"
                    [style.width.pt]="arColumnWidthsPt[col.key]" />
                </colgroup>
                <tr *ngFor="let charge of shipment.charges">
                  <td
                    *ngFor="let col of arChargeBlockColumns"
                    class="ar-nowrap"
                    [class.ar-amount]="col.key === 'charges'">
                    {{
                      col.key === 'charges'
                        ? formatArAmount(charge.chargeAmount)
                        : charge.chargeCode || charge.chargeDescription
                    }}
                  </td>
                </tr>
                <tr class="ar-total-line">
                  <td
                    *ngFor="let col of arChargeBlockColumns"
                    class="ar-nowrap"
                    [class.ar-amount]="col.key === 'charges'">
                    {{
                      col.key === 'charges'
                        ? formatArAmount(shipment.total)
                        : 'TOT'
                    }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="ar-bold ar-invoice-totals-for">
        Totals For: {{ arInvoicePrint.accountName | uppercase }}
      </div>
      <div class="ar-invoice-totals">
        <div>
          <div>Pcs: {{ arInvoicePrint.totalPieces }}</div>
          <div>Wt: {{ arInvoicePrint.totalWeight }} lbs.</div>
        </div>
        <div class="ar-bold ar-nowrap">Total Charges Due:</div>
        <div
          class="ar-bold ar-nowrap ar-amount"
          [style.width.pt]="arColumnWidthsPt['charges']">
          {{ formatArAmount(arInvoicePrint.totalDue) }}
        </div>
      </div>
    </div>

    <!-- PAC-24667: Shipment grid (shared by bag, manifest and linked-shipment blocks) -->
    <ng-template #shipmentGrid let-shipments>
      <table
        class="ibc-print-table"
        *ngIf="shipments?.length && hasShipmentColumns">
        <thead>
          <tr>
            <th
              scope="col"
              *ngIf="showShipmentExt"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.shipment }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showOrigin"
              [style.flex]="'0 0 ' + defaultPrintWidth.ml + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.origin }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showDestination"
              [style.flex]="'0 0 ' + defaultPrintWidth.ml + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.destination }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showShipmentWeight"
              [style.flex]="'0 0 ' + defaultPrintWidth.small + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.weight }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showShipper"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.shipperDetails }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showConsignee"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.consigneeDetails }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showCommodityColumn"
              [style.flex]="'0 0 ' + defaultPrintWidth.large + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.commodityDetails }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let shipment of shipments">
            <td
              *ngIf="showShipmentExt"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <span class="ibc-body-text-regular table-text">
                {{ shipment.shipmentExt }}
              </span>
            </td>
            <td
              *ngIf="showOrigin"
              [style.flex]="'0 0 ' + defaultPrintWidth.ml + 'px'">
              <div class="ibc-body-text-regular table-text">
                {{ shipment.origin }}
              </div>
            </td>
            <td
              *ngIf="showDestination"
              [style.flex]="'0 0 ' + defaultPrintWidth.ml + 'px'">
              <div class="ibc-body-text-regular table-text">
                {{ shipment.destination }}
              </div>
            </td>
            <td
              *ngIf="showShipmentWeight"
              [style.flex]="'0 0 ' + defaultPrintWidth.small + 'px'">
              <span class="ibc-body-text-regular table-text">
                {{ shipment.weight }}
              </span>
            </td>
            <!-- Shipper -->
            <td
              *ngIf="showShipper"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-regular table-text">
                <div>{{ getPartyName(shipment.shipperDetails) }}</div>
                <div>{{ getPartyCompany(shipment.shipperDetails) }}</div>
                <div>{{ getPartyAddress(shipment.shipperDetails) }}</div>
              </div>
            </td>
            <!-- Consignee -->
            <td
              *ngIf="showConsignee"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-regular table-text">
                <div>{{ getPartyName(shipment.consigneeDetails) }}</div>
                <div>{{ getPartyCompany(shipment.consigneeDetails) }}</div>
                <div>{{ getPartyAddress(shipment.consigneeDetails) }}</div>
              </div>
            </td>
            <!-- Commodity Details -->
            <td
              *ngIf="showCommodityColumn"
              [style.flex]="'0 0 ' + defaultPrintWidth.large + 'px'">
              <div class="ibc-body-text-regular table-text">
                <ng-container
                  *ngFor="
                    let commodity of shipment.commodityDetails;
                    let i = index
                  ">
                  <div>{{ bagLinkedKeys.commodityText }}{{ i + 1 }}</div>
                  <div *ngIf="shouldShowCommodityField('hsCode')">
                    {{ getCommodityFieldNumber('hsCode') }}.
                    {{ bagLinkedKeys.hSCode }}: {{ commodity.hsCode }}
                  </div>

                  <div *ngIf="shouldShowCommodityField('commodityValue')">
                    {{ getCommodityFieldNumber('commodityValue') }}.
                    {{ bagLinkedKeys.commodityValue }}:
                    {{ commodity.commodityValue }}
                  </div>

                  <div *ngIf="shouldShowCommodityField('commodityDescription')">
                    {{ getCommodityFieldNumber('commodityDescription') }}.
                    {{ bagLinkedKeys.commodityDescription }}:
                    {{ commodity.commodityDescription }}
                  </div>

                  <br *ngIf="i < shipment.commodityDetails.length - 1" />
                </ng-container>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-template>

    <!-- PAC-24667: Bag grid followed by its own Shipment grid -->
    <ng-template #bagBlock let-bag>
      <table
        class="ibc-print-table nested-bag-table"
        *ngIf="showBag || showBagWeight">
        <thead>
          <tr>
            <th
              scope="col"
              *ngIf="showBag"
              [style.flex]="'0 0 ' + defaultPrintWidth.medium + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.bag }}
              </div>
            </th>
            <th
              scope="col"
              *ngIf="showBagWeight"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <div class="ibc-body-text-large-bold table-text">
                {{ bagLinkedKeys.weight }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              *ngIf="showBag"
              [style.flex]="'0 0 ' + defaultPrintWidth.medium + 'px'">
              <span class="ibc-body-text-regular table-text">
                {{ bag.bagExt }}
              </span>
            </td>
            <td
              *ngIf="showBagWeight"
              [style.flex]="'0 0 ' + defaultPrintWidth.maxSmall + 'px'">
              <span class="ibc-body-text-regular table-text">
                {{ bag.weight }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-container
        *ngTemplateOutlet="
          shipmentGrid;
          context: { $implicit: bag.shipmentDetails }
        "></ng-container>
    </ng-template>

    <!-- Manifest / Bag: linked bags -->
    <div
      *ngIf="
        bagsLinkedData.length &&
        (showBag || showBagWeight || hasShipmentColumns)
      ">
      <div class="section-header ibc-heading-h6-small-bold">
        {{ nestedBagsTitle || bagLinkedKeys.bagLinked }}
      </div>
      <ng-container *ngFor="let bag of bagsLinkedData">
        <ng-container
          *ngTemplateOutlet="
            bagBlock;
            context: { $implicit: bag }
          "></ng-container>
      </ng-container>
    </div>

    <!-- MAWB: linked manifests → bags → shipments -->
    <div
      *ngIf="
        manifestsLinkedData.length &&
        (showBag || showBagWeight || hasShipmentColumns)
      ">
      <div class="section-header ibc-heading-h6-small-bold">
        {{ entityPrintKeys.manifestsLinked }}
      </div>
      <ng-container *ngFor="let manifest of manifestsLinkedData">
        <div class="nested-sub-header ibc-body-text-large-bold">
          {{ entityPrintKeys.manifest }}: {{ manifest.manifestExt }}
        </div>
        <ng-container *ngFor="let bag of manifest.bags">
          <ng-container
            *ngTemplateOutlet="
              bagBlock;
              context: { $implicit: bag }
            "></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <!-- Shipment (Master): linked shipments -->
    <div *ngIf="linkedShipmentsData.length && hasShipmentColumns">
      <div class="section-header ibc-heading-h6-small-bold">
        {{ entityPrintKeys.linkedShipments }}
      </div>
      <ng-container
        *ngTemplateOutlet="
          shipmentGrid;
          context: { $implicit: linkedShipmentsData }
        "></ng-container>
    </div>
</div>
  <button
    class="ibc-medium-button ibc-primary-default-button cursor infoPage-preview-print-btn {{
      isInfoPagePrintClicked ? 'hide-btn' : 'show-btn'
    }}"
    (click)="print()">
    <span class="ibc-body-text-regular">
      {{ popupButtons.Print }}
    </span>
  </button>
</div>
